<template>
  <div>
    <a v-b-toggle.my-sidebar>
      <img src="./assets/menu.png" height="28px">
    </a>
    <img src="./assets/logo.png" height="24px">

    <b-sidebar id="my-sidebar" title="Menu" shadow>
      <div>
        <ul>
          <li>
            <router-link to="/">AUC-based dosing</router-link>
          </li>
          <li>
            <router-link to="/troughdose">Trough-based dosing</router-link>
          </li>
          <li>
            <router-link to="/ttg">Time to goal trough</router-link>
          </li>
          <li>
            <router-link to="/hddose">IHD dosing algorithm</router-link>
          </li>
          <li>
            <router-link to="/doserevise">Dose Revisions</router-link>
          </li>
          <li>
            <router-link to="/ref">Reference</router-link>
          </li>
        </ul>
      </div>
    </b-sidebar>
    <router-view></router-view>
    <Kmpfooter></Kmpfooter>
  </div>
</template>

<script>
import Kmpfooter from "./components/Kmpfooter.vue";

export default {
  name: "app",
  components: {
    Kmpfooter
  }
};
</script>

<style >
div {
  font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  width: 400px;
  margin: auto;
}
ul {
  margin: 0;
  margin-top: 15px;
  padding: 0;
}
li {
  margin-right: 8px;
  margin-left: 8px;
}
a:link,
a:visited,
a:hover,
a:active {
  text-decoration: none;
  color: #5b718a;
}
.title{
 font-size: 20px;
  margin-top: 10px;
  color: #364f6b;
  border-bottom: solid 1px;
}
div#warning {
  font-size: 15px;
  color: #a81064;
}
</style>
